import React from 'react';
import { filterOffers } from 'src/components/price-list/filtering';
import { useOfferListFilterContext } from '../offer-list-filter-context';
import ProductConditions from '../product-conditions';
import { Variants } from '../product-variants';
import { Category, ProductPageQuery } from 'src/types';
import { FiltersWrapper } from './styles';
import { getConditions } from '../product-conditions/utils';

const CATEGORY_SHOES = '1490';

export const ProductFilters: React.FC<IProductFilters> = props => {
  const { category, product } = props;
  const { getAdditiveFilters } = useOfferListFilterContext();
  const activeAdditiveFilters = getAdditiveFilters().filter(f => f.active);
  const isInShoeCategory =
    category?.path?.length &&
    category?.path?.length >= 1 &&
    category.path[1]?.id === CATEGORY_SHOES;
  const hasShoeSizeVariants = isInShoeCategory;

  // For the variant values calculation (the options in the variant dialog)
  // we use all values that can be found in initial offerlist + any offers added by the addative filters

  const filteredOffers = filterOffers(activeAdditiveFilters, product?.prices);

  const productConditions = getConditions(filteredOffers);

  return productConditions.length || hasShoeSizeVariants ? (
    <FiltersWrapper>
      {productConditions.length > 0 && (
        <ProductConditions productConditions={productConditions} />
      )}
      {hasShoeSizeVariants && <Variants offers={filteredOffers} />}
    </FiltersWrapper>
  ) : null;
};

interface IProductFilters {
  category?: Category | null;
  product: ProductPageQuery['product'];
}
